import ContactPage from './[lang]/contact';
export default ContactPage;
